import React, { useState, ChangeEvent, useEffect } from 'react';

interface TextInputProps {
    placeholder?: string;
    value?: string;
    additionalClass?: string;
    disabled?: boolean;
    onValueChange: (value: string) => void;
    idPrefix?: string;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const TextInput: React.FC<TextInputProps> = ({ placeholder, value, additionalClass, disabled, onValueChange, idPrefix, onKeyDown }) => {
    const [inputValue, setInputValue] = useState(value || "");

    useEffect(() => {
        if (value !== inputValue) {
            setInputValue(value || "");
        }
    }, [value]);

    useEffect(() => {
        setInputValue(value || '');
    }, [value])

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        const newValue = event.target.value;

        setInputValue(newValue);

        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    return (
        <input
            id={`${idPrefix ? `${idPrefix}-` : ""}text-input`}
            type="text"
            value={inputValue}
            onChange={handleInputChange}
            className={`form-control ${additionalClass ?? ""}`}
            placeholder={placeholder}
            disabled={disabled}
            onKeyDown={e => onKeyDown && onKeyDown(e)}
        />
    );
};

export default TextInput;
